import { _game, _GAMES, _user, _USER } from "@/state";
import { ModelDefaults } from "@/state/ModelDefaults";
import { str, obj, swal } from '@/util'
import store from '@/store';

export class Game {

	/*
	|-------------------------------------------------------------
	| Data
	|-------------------------------------------------------------
	*/

	state = () => _game()
	setState = (data = {}) => (Object.assign(this.state(), this.commit(data)))

	static stateDefaults = () => Object.assign({},
		ModelDefaults.Game(),
		{
			players: [],
			standings: [],
			sprint: null,
			sprints: []
		}
	)

	commit = (data = {}) => {
		if (data !== false) {
			let original = Object.assign(this.constructor.stateDefaults(), this);
			Object.assign(this, original, data);
			this.computedData();
			return obj.cleanCopy(this);
		}
		return this.constructor.stateDefaults()
	}

	computedData = () => { }

	/**
	 * defaults
	 */
	static defaults = () => ModelDefaults.Game()

	/*
	|-------------------------------------------------------------
	| Current
	|-------------------------------------------------------------
	*/

	getId = () => this.state().id || null

	unload = () => {
		_USER().clearStanding()
		return this.commit(false)
	}

	getStatus = () => this.state().status.toUpperCase()

	isStatus = (status) => !!(status.toUpperCase() == this.getStatus())

	isDraft = () => !!(this.state().id && this.isStatus('DRAFT'))

	isActive = () => !!(this.state().id && this.isStatus('ACTIVE'))

	isInactive = () => !!(this.state().id && this.isStatus('INACTIVE'))

	isEnded = () => !!(this.state().id && this.isStatus('ENDED'))

	onCurrentSprint = () => !!this.state().id && !!this.current_sprint && !!this.sprint && this.current_sprint.id === this.sprint.id

	/*
	|--------------------------------------------------------------------------
	| Local Storage Save
	|--------------------------------------------------------------------------
	*/

	loadSavedGame = async (data) => {
		data = Object.assign({ success: '' }, data)
		let activeGame = this.constructor.localStorage.get()
		if (!!activeGame) {
			try {
				let res = await store.dispatch('games/loadGame', { game: { id: activeGame } })
				if (!res) { throw res }
				if (data.success) { swal.success().isToast().fire({ title: data.success }) }
			} catch (e) {
				this.constructor.localStorage.remove()
			}
		}
	}

	static localStorage = {
		storageKey: 'activeGameId',
		get: () => {
			return localStorage.getItem(this.localStorage.storageKey) || null
		},
		set: (gameId) => {
			gameId = gameId || _game().id || ''
			localStorage.setItem(this.localStorage.storageKey, gameId)
		},
		remove: () => {
			localStorage.removeItem(this.localStorage.storageKey)
		}
	}

	/*
	|--------------------------------------------------------------------------
	| Changes
	|--------------------------------------------------------------------------
	*/

	updateInCollection = (obj = {}, matchWith = 'id') => {
		if (_.isEmpty(obj)) { return this.commit(); }
		_GAMES().items.updateItem(obj, matchWith).commitToState();
		if (this.id == obj.id) {
			Object.assign(this, obj);
		}
		return this;
	}

	removeFromCollection = (obj = {}, matchWith = 'id') => {
		if (_.isEmpty(obj)) { return this.commit(); }
		_GAMES().items.deleteItem(obj, matchWith).commitToState();
		if (this.id == obj.id) {
			obj = this.commit(false)
			Object.assign(this, obj);
		}
		return this;
	}

	/*
	|--------------------------------------------------------------------------
	| Sprints
	|--------------------------------------------------------------------------
	*/

	commitSprints = (sprints = []) => {
		this.setSprints(sprints)
			.updateCurrentSprintFromList(true)
		return this.commit();
	}

	setSprints = (sprints = []) => {
		this.sprints = sprints.filter(s => s.game_id == this.getId())
		return this
	}

	setCurrentSprint = (current_sprint = {}) => {
		this.current_sprint = current_sprint
		return this
	}

	setSprint = (sprint = {}) => {
		this.sprint = sprint
		return this
	}

	updateCurrentSprintFromList = (updateGame = false) => {
		let newCurrent = this.sprints.find(s => (!!s.current && s.game_id == this.getId())) || null
		this.setCurrentSprint(newCurrent)
		if (updateGame) {
			store.commit('games/UPDATE_GAME', obj.cleanCopy(this))
		}
		return this
	}

	getSprints = () => (this.state().sprints || [])

	getCurrentSprint = () => (this.state().current_sprint || null)

	getSprint = () => (this.state().sprint || null)

	/*
	|--------------------------------------------------------------------------
	| Players and Standing
	|--------------------------------------------------------------------------
	*/

	commitStandingsAndPlayers = (arr = []) => {
		this.updateStandings(arr)
		this.updatePlayersFromStandings()
		return this.commit();
	}

	loadTenantStandingsAndPlayers = (arr = []) => {
		this.commit(this.constructor.stateDefaults())
		this.standings = arr;
		return this.commit();
	}

	getStandings = () => (this.state().standings || [])

	getPlayers = () => (this.state().players || [])

	// Set Standing and position for current player
	updateStandings = (arr = []) => {
		this.standings = arr
		this.updatePlayerStanding()
		return this;
	}

	// Set a list of players using the standings
	updatePlayersFromStandings = () => {
		if (_.isEmpty(this.standings)) {
			return this
		}
		let players = _.sortBy(_.clone(this.standings), ['display_name']);
		return this.updatePlayers(players);
	}

	// Set list of players
	updatePlayers = (arr = [], withCurrent = true) => {
		this.players = arr
		if (!withCurrent) {
			this.players = arr.filter(p => p.id != _user().id);
		}
		return this
	}

	/*
	|--------------------------------------------------------------------------
	| The Player
	|--------------------------------------------------------------------------
	*/

	// Cherry pick authenticated user from standings
	updatePlayerStanding = () => {
		let player = this.standings.find(u => u.id == _user().id) || false;
		if (!!player) {
			player = {
				coin_counts: player.coin_counts,
				position: player.position
			}
			// Add to USer State
			_USER().setState(player)
		}
		return this
	}

	player = () => _USER()

	playerCoins = () => _USER().coins()

	playerPosition = () => _USER().standing()

	/*
	|--------------------------------------------------------------------------
	| GAME Coins
	|--------------------------------------------------------------------------
	*/

	coins = () => this.state().coin_counts || {}

	currentCoins = () => this.coins().current || 0

	lifetimeCoins = () => this.coins().lifetime || 0

	/*
	|--------------------------------------------------------------------------
	| Coin Labels
	|--------------------------------------------------------------------------
	*/

	pluraliseCoinsLabel = (count = 0, plural = null, singular = null) => {
		use = singular != null ? singular : 'Coin'
		plural = plural != null ? plural : 'Coins'
		var use = 'Coin';
		if ([1, -1].indexOf(count) < 0) { use = plural; }
		return use;
	}

	pluraliseCoins = (count = 0, plural = null, singular = null) => {
		plural = plural != null ? plural : 'Coins'
		singular = singular != null ? singular : 'Coin'
		return str.pluralise(count, plural, singular);
	}

}